import { BaseApi } from 'src/api/BaseApi';
import { DEMO_QUERIES, DEMO_QUERY_DETAILS } from 'src/api/demo/queries';

class QueryApi extends BaseApi {
  // async fetchQueries(queryStatuses, queryCount = '250', options = {}) {
  //   if (this.isDemo()) {
  //     // Filter demo queries by status(es)
  //     const statuses = Array.isArray(queryStatuses) ? queryStatuses : [queryStatuses];
  //     return DEMO_QUERIES.filter((query) => statuses.includes(query.status));
  //   }

  //   const { startDate, endDate, dateField = 'pullTime' } = options;

  //   const formData = this.createFormData({
  //     queryStatus: Array.isArray(queryStatuses) ? queryStatuses[0] : queryStatuses,
  //     queryCount,
  //     ...(startDate && { startDate }),
  //     ...(endDate && { endDate }),
  //     ...(startDate && endDate && { dateField }),
  //   });

  //   const response = await this.postRequest('queries/test', formData);

  //   return response.data;
  // }

  async fetchQueries(queryStatuses, queryCount = '250') {
    if (this.isDemo()) {
      // Filter demo queries by status(es)
      const statuses = Array.isArray(queryStatuses) ? queryStatuses : [queryStatuses];
      return DEMO_QUERIES.filter((query) => statuses.includes(query.status));
    }

    const formData = this.createFormData({
      queryStatus: Array.isArray(queryStatuses) ? queryStatuses[0] : queryStatuses,
      queryCount,
    });

    const response = await this.postRequest('queries', formData);

    return response.data;
  }

  async fetchQueryByID(queryID) {
    if (this.isDemo()) {
      return DEMO_QUERY_DETAILS[queryID] || DEMO_QUERY_DETAILS[1];
    }

    const formData = this.createFormData({
      queryID,
    });

    const response = await this.postRequest('queries', formData);

    console.log('response', response);

    return response.data;
  }

  async updateLead(leadID, sendToExpert, returnedEmailFromExpert, sendToQuery) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        leadID,
        updated: true,
      });
    }

    const formData = this.createFormData({
      leadID,
    });

    if (sendToExpert) {
      formData.append('sendToExpert', sendToExpert);
    }

    if (returnedEmailFromExpert) {
      formData.append('returnedEmailFromExpert', returnedEmailFromExpert);
    }

    if (sendToQuery) {
      formData.append('sendToQuery', sendToQuery);
    }

    const response = await this.postRequest('leads/update', formData);

    return response.data;
  }

  async updateQuery(queryID, newStatus, userID, leadID, expertID) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        queryID,
        status: newStatus,
        updated: true,
      });
    }

    const formData = this.createFormData({
      queryID,
    });

    if (newStatus) {
      formData.append('status', newStatus);
    }

    if (userID) {
      formData.append('userID', userID.toString());
    }

    if (leadID) {
      formData.append('leadID', leadID.toString());
    }

    if (expertID) {
      formData.append('expertsID', expertID.toString());
    }

    const response = await this.postRequest('queries/update', formData);

    return response;
  }

  async successfulPlacement(queryID, expertID, mediaURL, emails) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        queryID,
        expertID,
        mediaURL,
        emailsSent: emails?.length || 0,
      });
    }

    const formData = this.createFormData({
      queryID,
      expertID,
    });

    if (mediaURL) {
      formData.append('mediaURL', mediaURL);
    }

    if (emails && emails.length > 0) {
      formData.append('emails', JSON.stringify(emails));
    }

    const response = await this.postRequest('experts/sendemail', formData);

    return response.data;
  }

  async createQuery(params) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        query: {
          ...params,
          id: Date.now(),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const formData = this.createFormData({
      title: params.title,
      description: params.description,
      status: params.status,
      source: params.source,
      createdBy: params.createdBy,
      topics: params.topics,
    });

    if (params.queryURL) formData.append('queryURL', params.queryURL);
    if (params.mediaOutlet) formData.append('mediaOutlet', params.mediaOutlet);
    if (params.dueDate) formData.append('dueDate', params.dueDate);
    if (params.expertsID) formData.append('expertsID', params.expertsID.toString());
    if (params.emailSentOut) formData.append('emailSentOut', params.emailSentOut.toString());
    if (params.userClaimID) formData.append('userClaimID', params.userClaimID.toString());
    if (params.notes) formData.append('notes', params.notes);

    const response = await this.postRequest('queries/create', formData);
    return response.data;
  }

  async updateQueryV2(params) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        queryID: params.queryID,
        query: {
          ...params,
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const formData = this.createFormData({
      queryID: params.queryID,
      title: params.title,
      description: params.description,
      source: params.source,
      topics: params.topics,
    });

    if (params.status) formData.append('status', params.status);
    if (params.queryURL) formData.append('queryURL', params.queryURL);
    if (params.mediaOutlet) formData.append('mediaOutlet', params.mediaOutlet);
    if (params.dueDate) formData.append('dueDate', params.dueDate);
    if (params.expertsID) formData.append('expertsID', params.expertsID.toString());
    if (params.emailSentOut) formData.append('emailSentOut', params.emailSentOut.toString());
    if (params.userClaimID) formData.append('userClaimID', params.userClaimID.toString());
    if (params.createdBy) formData.append('createdBy', params.createdBy.toString());
    if (params.notes) formData.append('notes', params.notes);
    if (params.mediaURL) formData.append('mediaURL', params.mediaURL);

    const response = await this.postRequest('queries/updatev2', formData);
    return response.data;
  }
}

export const queryApi = new QueryApi();
